import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { IGeofence } from "@app/interfaces/IGeofences";
import { IGroupWithIds } from "@app/main/components/resourceManagement/groups/_models/IGroupWithIds";
import { IDriver } from "@interfaces/IDriver";
import { IUser } from "@interfaces/IUser";
import { IVehicle } from "@interfaces/IVehicle";
import { GroupService } from "@services/group.service.ajs";
import "./resourceGroupDisplay.scss";

@Component({
    selector: "resource-group-display",
    template: require("./resourceGroupDisplay.html")
})
export class ResourceGroupDisplayComponent implements OnInit, OnChanges {

    // Bindings

    @Input() groups: IGroupWithIds[];
    @Input() vehicle: IVehicle;
    @Input() driver: IDriver;
    @Input() geofence: IGeofence;
    @Input() user: IUser;
    @Input() max: number;

    // Internal

    displayGroups: IGroupWithIds[] = [];
    hiddenGroups: IGroupWithIds[] = [];
    tooltipLabel: string;

    constructor(private groupService: GroupService) {
    }

    ngOnInit(): void {
        this.loadGroups();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return;
        }

        this.loadGroups();
    }

    // ----------------------------------

    private loadGroups(): void {
        if (this.groups) {
            this.mapGroups();
        }
        else {
            this.groupService.getGroupsWithFullMappings(false).then(groups => {
                this.groups = groups;

                this.mapGroups();
            });
        }
    }

    private mapGroups(): void {
        this.displayGroups = [];
        this.hiddenGroups = []

        if (!this.groups) {
            return;
        }

        this.tooltipLabel = "";

        this.groups.forEach(group => {
            if (!this.user) {
                this.populateGroup(group, "Vehicle");
                this.populateGroup(group, "Driver");
            }
            else {
                this.populateGroupUsers(group);
            }
        });
    }

    private populateGroup(group: IGroupWithIds, resourceName: "Driver" | "Vehicle"): void {
        let found = false;

        switch (resourceName) {
            case "Driver":
                found = group.DriverIds.includes(this.driver?.Id);
                break;

            case "Vehicle":
                found = group.VehicleIds.includes(this.vehicle?.Id);
                break;
        }

        if (found) {
            this.addGroup(group);
        }
    }
    

    private isAtMaxLimit(): boolean {
        if (!this.max) {
            return false;
        }

        return this.max <= this.displayGroups.length;
    }

    private populateGroupUsers(group: IGroupWithIds) {
        for (let i = 0; i < this.user.GroupIds.length; i++) {
            const groupId = this.user.GroupIds[i];

            if (groupId == group.Id) {
                this.addGroup(group);
                break;
            }
        }        
    }

    private addGroup(group: IGroupWithIds): void {
        // Sometimes we have duplicates, this helps avoid that
        const groupFound = this.displayGroups.find(x => x.Id === group.Id);

        if (groupFound) {
            return;
        }

        if (this.isAtMaxLimit()) {
            this.hiddenGroups.push(group);
            this.addGroupToTooltip(group);
        }
        else {
            this.displayGroups.push(group);
        }
    }

    private addGroupToTooltip(group: IGroupWithIds): void {

        if (this.tooltipLabel.length != 0) {
            this.tooltipLabel += ", ";
        }

        this.tooltipLabel += group.Name;
    }
}
